"use client";

import * as React from "react";
import { ArrowRight, Cake } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function FinalCta() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="169138" id="cierre-cta" className="bg-background py-24 md:py-32 overflow-hidden">
      <div className="container mx-auto px-4 md:px-6">
        <div ref={ref} className={`mx-auto max-w-3xl text-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          <div className="inline-flex items-center justify-center p-3 bg-accent-light rounded-md mb-8 shadow-soft">
            <Cake className="size-8 text-accent" aria-hidden="true" />
          </div>
          
          <h2 className="font-display text-4xl md:text-5xl lg:text-6xl font-bold tracking-tight text-foreground mb-6">
            ¿Estás listo para dar el siguiente paso?
          </h2>
          
          <p className="font-sans text-lg md:text-xl text-muted-foreground mb-10 max-w-2xl mx-auto leading-relaxed">
            Inicia hoy mismo tu camino hacia el crecimiento personal y profesional con sesiones de coaching diseñadas específicamente para alcanzar tus metas.
          </p>
          
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <Button size="lg" className="w-full sm:w-auto rounded-md px-8 h-14 text-base bg-primary text-foreground-primary hover:bg-primary-hover shadow-medium transition-all" asChild>
              <Link to="/CoachingSessionsPage">
                Ver sesiones
                <ArrowRight className="ml-2 size-5" aria-hidden="true" />
              </Link>
            </Button>
            
            <Button size="lg" variant="outline" className="w-full sm:w-auto rounded-md px-8 h-14 text-base border-primary text-primary hover:bg-primary-light transition-all" asChild>
              <Link to="/AboutMePage">
                Sobre mí
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}